import { styled } from '@mui/material/styles';
import { Dialog, InputAdornment, TextField, DialogContent, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';

export const StyledDialog = styled(Dialog, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<{ isMobile: boolean }>(({ isMobile }) => ({
  ...(isMobile && {
    '& .MuiDialog-paper': {
      margin: 0,
      width: '100%',
      height: '100%',
      maxHeight: '100%',
      borderRadius: 0
    }
  })
}));

export const StyledSearchField = styled((props: any) => (
  <TextField
    {...props}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Search fontSize="small" />
        </InputAdornment>
      )
    }}
  />
))(() => ({
  marginBottom: 16
}));

export const StyledDialogContent = styled(DialogContent, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<{ isMobile: boolean }>(({ isMobile }) => ({
  ...(isMobile && {
    paddingLeft: 16,
    paddingRight: 16
  })
}));

export const DescriptionText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<{ isMobile: boolean }>(({ isMobile }) => ({
  marginBottom: 16,
  ...(isMobile && {
    fontSize: '0.9rem'
  })
}));
